// store/authStore.js
import { create } from "zustand";
import { getGalleryImage, getGalleryPage } from "../api/gallery";
import { getBannerData } from "../api/home";

export const useGalleryStore = create((set, get) => ({
    banner: null,
    loading: true,
    gallery: [],
    emergencyServicesGallery: [],
    residentialConcreteGallery: [],
    emergencyServices: null,
    residentialConcrete: null,

    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('gallery')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getgalleryimage: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await getGalleryImage(pageNumber, pageSize, search, field)
            set({ gallery: res?.galleries })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getgallerypage: async () => {
        try {
            const res = await getGalleryPage()
            set({
                emergencyServices: res?.emergencyServices, residentialConcrete: res?.residentialConcrete
            })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    }

}));
